import * as React from 'react'

import { useMenu } from 'components/ds'

type Props = {
  handleRenameProject: () => void
  handleOpenSettings: () => void
  handleDeleteProject: () => void
}

/**
 * The brief project menu items, shared by the three-dot menu and the row's
 * right-click menu so the two can never drift apart.
 */
const BriefProjectMenuBody = ({
  handleRenameProject,
  handleOpenSettings,
  handleDeleteProject,
}: Props): React.ReactNode => {
  const Menu = useMenu()

  return (
    <>
      <Menu.Item onClick={handleRenameProject}>Rename project</Menu.Item>
      <Menu.Item onClick={handleOpenSettings}>Project notes</Menu.Item>
      <Menu.Item color="red" onClick={handleDeleteProject}>
        Delete project
      </Menu.Item>
    </>
  )
}

export default BriefProjectMenuBody
